<template>
  <Slider
    :value="value"
    :ticks-labels="ticksLabels"
  />
</template>

<script>
import Slider from '@/components/atoms/Slider'

export default {
  name: 'ResourceTypeSlider',
  components: {
    Slider,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ticksLabels () {
      return [
        'データサイエンティスト(アナリスト)',
        '',
        '',
        '',
        '機械学習(ML)エンジニア',
      ]
    }
  },
}
</script>
